// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7b996557\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../vux-loader/src/after-less-loader.js!../../../../less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../vux-loader/src/style-loader.js!../../../../vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../../vue-style-loader/lib/addStylesClient.js")("bd755102", content, true);


//////////////////
// WEBPACK FOOTER
// ./~/vue-style-loader!./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7b996557","scoped":false,"hasInlineConfig":false}!./~/vux-loader/src/after-less-loader.js!./~/less-loader/dist/cjs.js?{"sourceMap":false}!./~/vux-loader/src/style-loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./~/vux/src/components/group/index.vue
// module id = 363
// module chunks = 1